<template>
  <main class="main profile-page sell-offers-page page-inside">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="tab-list">
            <router-link to="/profile" class="item"
              >Account</router-link
            >
            <router-link v-if="$parent.offerEnabled" to="/offers" class="item">My Offers</router-link>
            <router-link to="/orders" class="item">Order history</router-link>
            <div @click="$parent.logout" class="item">Log Out</div>
          </div>
          <div class="profile-table" v-if="$parent.orderHistory">
            <div class="profile-table-wrapper profile-form-wrapper">
              <div class="table-container">
                <table>
                  <thead>
                    <tr>
                      <td>ID</td>
                      <td>Date/time</td>
                      <td>Skin name</td>
                      <td>Total</td>
                      <td>Status</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in $parent.orderHistory" :key="i">
                      <td>{{ item.id }}</td>
                      <td>{{ formatToEST(item.created_at) }}</td>
                      <td>{{ item.title }}</td>
                      <td>
                        <PriceFormatter
                          v-if="hasInternalPrice(item)"
                          :price="displayInternalSum(item)"
                        />
                        <span v-else class="order-fiat-price">
                          {{ formatAmount(displayFiatSum(item)) }}
                          {{ displayFiatCurrency(item) }}
                        </span>
                      </td>
                      <td>{{ item.status }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="pagination" id="pagination"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment-timezone";
import PriceFormatter from "../components/PriceFormatter.vue";
export default {
  name: "SellOffers",
  props: [],
  components: {
    PriceFormatter,
  },
  data: function () {
    return {};
  },
  methods: {
    openOfferDetailsModal() {
      this.$emit("openOfferDetailsModal");
    },
    formatToEST(timestamp) {
      // const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      // console.log(userTimeZone); // users timezone
      if (!timestamp) return "";
      const momentObj =
        typeof timestamp === "number"
          ? moment.unix(timestamp)
          : moment(timestamp, "DD.MM.YYYY HH:mm");

      return momentObj.tz("Europe/Tallinn").format("DD.MM.YYYY HH:mm");
    },
    displayInternalSum(item) {
      return item.internal_sum ?? item.sum;
    },
    hasInternalPrice(item) {
      return item.internal_sum !== undefined && item.internal_sum !== null;
    },
    displayFiatSum(item) {
      return item.fiat_sum ?? item.sum;
    },
    displayFiatCurrency(item) {
      return item.fiat_currency || item.currency || this.currency;
    },
    formatAmount(value) {
      const numericValue = parseFloat(value);

      if (Number.isNaN(numericValue)) {
        return value;
      }

      return numericValue.toFixed(2);
    },
  },
  computed: {
    ...mapGetters("app", ["currency"]),
  },
};
</script>
<style scoped>
.order-fiat-price {
  color: #1e2329;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: normal;
  white-space: nowrap;
}
</style>
